import Axios from "axios";
export const GetStudentProgressByStudent = async (student_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "studentProgressByStudent/",
        {
            student_id
        }
        , {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
    return res.data
}

export const GetAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff = async (subsidiary_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff/", {
        subsidiary_id
    }, {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetTeacherClassById = async (class_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getTeacherClassById/", {
        class_id
    }, {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

export const GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary = async (subsidiary_id, employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary/", {
            subsidiary_id,
            employee_id
        },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error recibiendo recibos de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetAllTeacherClassesNoEliminatedNoDaysOffNoFinished = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getAllTeacherClassesNoEliminatedNoDaysOffNoFinished/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

export const PostDefinitiveWithdrawStudent = async (student_id) => {

    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postDefinitiveWithdrawStudent/", {
            student_id
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}